<template>
  <div>
    <header class="index_web_head web_head">
      <!-- <div class="head_top"></div> -->
      <div class="head_bottom">
        <nav class="nav_wrap layout">
          <figure class="logo">
            <img src="../assets/image/f_home/logo.png" alt="logo" />
            <span>KINTOP TECH</span>
          </figure>

          <ul class="head_nav">
            <li v-for="(item, k) in nav" :key="k">
              <div @click="openFun(item)" :style="$store.state.routerName == item.url ? 'color:#409EFF' : ''
                ">
                {{ item.name }}
                <b v-if="item.hasOwnProperty('children')"></b>
              </div>
              <ul :class="item.children ? $store.state.routerName : ''">
                <li v-for="(item2, k2) in item.children" :key="k2">
                  <div>{{ item2.name }}</div>
                  <ul>
                    <li v-for="(item3, k3) in item2.children" :key="k3">
                      <div>{{ item3.name }}</div>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
          <!--change-language-->
          <!-- <div class="change-language ensemble">
            <div class="change-language-info">
              <div class="change-language-title medium-title">
                <div class="language-flag language-flag-en">
                  <a href=""><b class="country-flag" style="margin-top: -8px"></b><span>English</span>
                  </a>
                </div>
                <b class="language-icon"></b>
              </div>
              <div class="change-language-cont sub-content">
                <div class="empty"></div>
              </div>
            </div>
          </div> -->
        </nav>
      </div>
    </header>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navshow: "/f_home",
      nav: [
        // {
        //   url: "0",
        //   name: "一级",
        //   children: [
        //     { url: "1", name: "二级" },
        //     {
        //       url: "2",
        //       name: "二级2",
        //       children: [
        //         { url: "3", name: "三级" },
        //         { url: "4", name: "三级2" }
        //       ]
        //     }
        //   ]
        // }
        {
          url: "/f_home",
          name: "HOME"
        },
        {
          url: "/h_product",
          name: "PRODUCTS" //产品
        },
        {
          url: "/f_TECH",
          name: "TECH ARTICLE" //技术
        },
        {
          url: "/f_FAQ",
          name: "FAQ" //问答
        },
        {
          url: "/h_newslist",
          name: "NEWS" //新闻
        },
        {
          url: "/f_aboutUs",
          name: "ABOUT US" //关于我们
        },
        {
          url: "/h_contactUs",
          name: "CONTACT US" //联系我们
        }
      ]
    };
  },
  mounted() {
    setTimeout(() => {
      this.$store.commit("routerName", this.$route.path);
    }, 500)
  },
  methods: {
    openFun(row) {
      this.navshow = row.url;
      console.log(this.$store.state.routerName, this.navshow);
      if (this.$store.state.routerName == this.navshow) {
        window.location.reload();
        return;
      }
      this.$store.commit("routerName", this.navshow);
      this.$router.push({ path: row.url });
    }
    // other(e) {
    //   this.navshow = "sub-menu";
    // },
    // outher(e) {
    //   this.navshow = "";
    // }
  }
};
</script>
<style scoped>
a {
  text-decoration: none;
}

@font-face {
  font-weight: normal;
  font-style: normal;
  font-family: "fontawesome";
  src: url("../assets/fonts/fontawesome-webfont.ttf");
}

.web_head .layout {
  padding: 0 5vw;
  width: 100%;
}

@media screen and (max-width: 1500px) {
  .web_head .layout {
    padding: 0 1vw;
    width: 100%;
  }
}

.web_head {
  position: relative;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  width: 100%;
}

.web_head.index_web_head {
  position: absolute;
}

.web_head .head_bottom {
  background: #00000a;
}

.web_head.index_web_head .head_bottom {
  background: transparent;
}

.web_head.index_web_head .head_bottom .layout {
  align-items: center;
  -webkit-align-items: center;
  background: #000000;
}

/*head_top*/
.head_top {
  height: 20px;
  background: #000000;
}

.head_contact {
  position: relative;
  float: left;
}

.web_head .change-language {
  position: relative;
  float: right;
  display: inline-block;
  vertical-align: middle;
  text-align: left;
}

.web_head .change-language-title {
  position: relative;
}

.web_head .change-language .change-language-cont {
  border-radius: 3px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
}

.change-language .change-language-title,
.change-language .change-language-title a {
  color: #fff;
}

/*head_bottom*/
.head_bottom {
  position: relative;
}

.web_head .logo {
  display: flex;
  flex: auto;
  flex: none;
  width: 350px;
}

.web_head .logo img {
  width: auto;
  max-height: 65px;
}

.web_head .logo span {
  color: #fff;
  font-size: 26px;
  font-weight: 600;
  margin-left: 10px;
  line-height: 65px;
}

.web_head .btn--search {
  position: relative;
  display: inline-block;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  margin-left: 38px;
  width: 35px;
  height: 26px;
  vertical-align: middle;
  cursor: pointer;
}

.web_head .btn--search:after,
.web_head .btn--search:before {
  display: inline-block;
  width: 100%;
  height: 26px;
  background: url("../assets/image/f_home/c366de26.jpg");
  background-position: center;
  background-repeat: no-repeat;
  content: "";
  vertical-align: top;
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.web_head .btn--search:after {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  -webkit-transform: scale(0.6) translateY(60%);
  -o-transform: scale(0.6) translateY(60%);
  transform: scale(0.6) translateY(60%);
  filter: alpha(opacity=0);
  -ms-transform: scale(0.6) translateY(60%);
}

.web_head .btn--search:hover:after {
  opacity: 0.6;
  -webkit-transform: unset;
  -o-transform: unset;
  transform: unset;
  -ms-transform: unset;
  filter: alpha(opacity=60);
}

.web_head .btn--search:hover:before {
  opacity: 0;
  -webkit-transform: scale(0.6) translateY(-60%);
  -o-transform: scale(0.6) translateY(-60%);
  transform: scale(0.6) translateY(-60%);
  -ms-transform: scale(0.6) translateY(-60%);
}

/*nav*/

.web_head .nav_wrap .head_nav {
  position: relative;
}

.head_nav>li {
  position: relative;
  display: inline-block;
  padding: 0 30px 0 0;
}

.head_nav>li>div {
  position: relative;
  display: inline-block;
  color: #fff;
  /* text-transform: uppercase; */
  font-size: 18px;
  font-family: Arial;
  line-height: 26px;
  cursor: pointer;
  padding-right: 20px;
}

.head_nav>li ul li {
  position: relative;
  font-size: 16px;
  line-height: 28px;
}

.head_bottom .layout {
  display: flex;
  height: 94px;
  -webkti-display: flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
}

.head_nav li div b {
  position: absolute;
  top: 50%;
  right: 0;
  display: inline-block;
  overflow: hidden;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  width: 19px;
  height: 19px;
  text-align: center;
  line-height: 19px;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

.head_nav li>div b:before {
  content: "\f107";
  font-family: "fontawesome";
  /* 1 */
}

.head_nav li ul {
  position: absolute;
  left: 20px;
  display: block;
  padding: 10px;
  width: 250px;
  border-top: 2px solid #fb7707;
  border-radius: 0 0 5px 5px;
  background-color: #fff;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);
  opacity: 0;
  -webkit-transition: all ease-in-out 0.35s;
  transition: all ease-in-out 0.35s;
  -webkit-transform: scaleY(0);
  transform: scaleY(0);
  -webkit-transform-origin: top;
  transform-origin: top;
}

.head_nav>li ul li {
  position: relative;
  font-size: 16px;
  line-height: 28px;
}

.head_nav>li ul li div {
  position: relative;
  display: block;
}

.head_nav>li ul li div b {
  top: 12px;
}

.head_nav>li ul li div b:before {
  content: "\f105";
}

.head_nav li ul ul {
  top: 0px;
  left: 240px;
  margin-left: 2px;
  border-radius: 3px;
}

.head_nav>li>div:hover b {
  -webkit-transform: rotateX(180deg);
  -o-transform: translateY(-50%) rotate(180deg);
  transform: translateY(-50%) rotate(180deg);
  -ms-transform: translateY(-50%) rotate(180deg);
}

.head_nav li ul.sub-menu {
  display: block !important;
  opacity: 1 !important;
  -webkit-transform: scaleY(1) !important;
  transform: scaleY(1) !important;
}

/* language */
.prisna-wp-translate-seo {
  display: none;
  font-family: Arial, Helvetica, sans-serif;
}

.change-language .prisna-wp-translate-seo,
.mobile-head-language .prisna-wp-translate-seo {
  display: block;
}

.change-language .change-language-title,
.change-language .change-language-title a {
  font-size: 10pt;
}

.change-language .change-language-title a:after {
  display: inline-block;
  padding-left: 2px;
  content: "\f0d7";
  font-size: 12px;
  font-family: fontawesome;
}

.change-language:hover .change-language-title a:after {
  -webkit-transform: rotate(-180deg);
  -moz-transform: rotate(-360deg);
  -o-transform: rotate(-180deg);
  transform: rotate(-180deg);
  -ms-transform: rotate(-180deg);
}

.change-language .change-language-cont {
  position: absolute;
  top: 36px;
  right: 0;
  z-index: 999;
  visibility: hidden;
  overflow-y: scroll;
  padding: 20px 10px 20px 20px;
  width: 360px;
  max-height: 80vh;
  border: 1px solid #eee;
  border-radius: 5px;
  background: #fff;
  opacity: 0;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  transform: scale3d(0.9, 0.9, 1);
  -ms-transition: all 0.3s ease-in-out;
}

.change-language:hover .change-language-cont {
  visibility: visible;
  opacity: 1;
  transform: scale3d(1, 1, 1);
}

.change-language .change-language-cont li {
  display: inline-block;
  overflow: hidden;
  margin: 0 0 10px;
  padding: 0 10px 0 0;
  width: 30%;
  vertical-align: top;
  font-size: 10pt;
}

.change-language .change-language-cont li a:hover {
  color: #fb7707;
}

.change-language .change-language-cont .lang-item-hide {
  display: none !important;
}

.change-language .change-language-cont .lang-more {
  position: relative;
  display: block;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}

.change-language .change-language-cont .more-active {
  font-size: 20px;
}

.language-flag span {
  position: relative;
  display: inline-block;
  overflow: hidden;
  padding: 0 0 0 33px;
  vertical-align: top;
  white-space: nowrap;
}

.change-language ::-webkit-scrollbar {
  width: 5px;
}

.change-language ::-webkit-scrollbar-track {
  background-color: #fff;
}

.change-language ::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.3);
}

.change-language .language-cont:hover::-webkit-scrollbar-thumb {
  display: block;
}

.language-flag .country-flag {
  position: absolute;
  top: 50%;
  left: 0;
  display: inline-block;
  margin: -1px 5px 0;
  width: 22px;
  height: 16px;
  background: url("../assets/image/f_home/all-m.jpg");
  background-repeat: no-repeat;
  vertical-align: top;
}

li.language-flag a {
  position: relative;
}

.language-flag-af .country-flag {
  background-position: 0 0 !important;
}

.language-flag-sq .country-flag {
  background-position: 0 -16px !important;
}

.language-flag-ar .country-flag {
  background-position: 0 -32px !important;
}

.language-flag-hy .country-flag {
  background-position: 0 -48px !important;
}

.language-flag-az .country-flag {
  background-position: 0 -64px !important;
}

.language-flag-eu .country-flag {
  background-position: 0 -80px !important;
}

.language-flag-be .country-flag {
  background-position: 0 -96px !important;
}

.language-flag-bg .country-flag {
  background-position: 0 -112px !important;
}

.language-flag-ca .country-flag {
  background-position: 0 -128px !important;
}

.language-flag-zh .country-flag {
  background-position: 0 -144px !important;
}

.language-flag-zh-TW .country-flag {
  background-position: 0 -160px !important;
}

.language-flag-hr .country-flag {
  background-position: 0 -176px !important;
}

.language-flag-cs .country-flag {
  background-position: 0 -192px !important;
}

.language-flag-da .country-flag {
  background-position: 0 -208px !important;
}

.language-flag-nl .country-flag {
  background-position: 0 -240px !important;
}

.language-flag-en .country-flag {
  background-position: 0 -256px !important;
}

.language-flag-et .country-flag {
  background-position: 0 -272px !important;
}

.language-flag-tl .country-flag {
  background-position: 0 -288px !important;
}

.language-flag-fi .country-flag {
  background-position: 0 -304px !important;
}

.language-flag-fr .country-flag {
  background-position: 0 -320px !important;
}

.language-flag-gl .country-flag {
  background-position: 0 -336px !important;
}

.language-flag-ka .country-flag {
  background-position: 0 -352px !important;
}

.language-flag-de .country-flag {
  background-position: 0 -368px !important;
}

.language-flag-el .country-flag {
  background-position: 0 -384px !important;
}

.language-flag-ht .country-flag {
  background-position: 0 -400px !important;
}

.language-flag-iw .country-flag {
  background-position: 0 -416px !important;
}

.language-flag-gu .country-flag,
.language-flag-hi .country-flag,
.language-flag-kn .country-flag,
.language-flag-ta .country-flag,
.language-flag-te .country-flag {
  background-position: 0 -432px !important;
}

.language-flag-hu .country-flag {
  background-position: 0 -448px !important;
}

.language-flag-is .country-flag {
  background-position: 0 -464px !important;
}

.language-flag-id .country-flag {
  background-position: 0 -480px !important;
}

.language-flag-ga .country-flag {
  background-position: 0 -496px !important;
}

.language-flag-it .country-flag {
  background-position: 0 -512px !important;
}

.language-flag-ja .country-flag {
  background-position: 0 -528px !important;
}

.language-flag-ko .country-flag {
  background-position: 0 -544px !important;
}

.language-flag-la .country-flag {
  background-position: 0 -560px !important;
}

.language-flag-lv .country-flag {
  background-position: 0 -576px !important;
}

.language-flag-lt .country-flag {
  background-position: 0 -592px !important;
}

.language-flag-mk .country-flag {
  background-position: 0 -608px !important;
}

.language-flag-ms .country-flag {
  background-position: 0 -624px !important;
}

.language-flag-mt .country-flag {
  background-position: 0 -640px !important;
}

.language-flag-no .country-flag {
  background-position: 0 -656px !important;
}

.language-flag-fa .country-flag {
  background-position: 0 -672px !important;
}

.language-flag-pl .country-flag {
  background-position: 0 -688px !important;
}

.language-flag-pt .country-flag {
  background-position: 0 -704px !important;
}

.language-flag-ro .country-flag {
  background-position: 0 -720px !important;
}

.language-flag-ru .country-flag {
  background-position: 0 -736px !important;
}

.language-flag-sr .country-flag {
  background-position: 0 -752px !important;
}

.language-flag-sk .country-flag {
  background-position: 0 -768px !important;
}

.language-flag-sl .country-flag {
  background-position: 0 -784px !important;
}

.language-flag-es .country-flag {
  background-position: 0 -800px !important;
}

.language-flag-sw .country-flag {
  background-position: 0 -816px !important;
}

.language-flag-sv .country-flag {
  background-position: 0 -832px !important;
}

.language-flag-th .country-flag {
  background-position: 0 -848px !important;
}

.language-flag-tr .country-flag {
  background-position: 0 -864px !important;
}

.language-flag-uk .country-flag {
  background-position: 0 -880px !important;
}

.language-flag-ur .country-flag {
  background-position: 0 -896px !important;
}

.language-flag-vi .country-flag {
  background-position: 0 -912px !important;
}

.language-flag-cy .country-flag {
  background-position: 0 -928px !important;
}

.language-flag-yi .country-flag {
  background-position: 0 -944px !important;
}

.language-flag-bn .country-flag {
  background-position: 0 -960px !important;
}

.language-flag-eo .country-flag {
  background-position: 0 -976px !important;
}

.language-flag.language-flag-custom-afghanistan .country-flag {
  background-position: 0 -992px !important;
}

.language-flag.language-flag-custom-albania .country-flag {
  background-position: 0 -1008px !important;
}

.language-flag.language-flag-custom-algeria .country-flag {
  background-position: 0 -1024px !important;
}

.language-flag.language-flag-custom-argentina .country-flag {
  background-position: 0 -1040px !important;
}

.language-flag.language-flag-custom-australia .country-flag {
  background-position: 0 -1056px !important;
}

.language-flag.language-flag-custom-austria .country-flag {
  background-position: 0 -1072px !important;
}

.language-flag.language-flag-custom-belgium .country-flag {
  background-position: 0 -1088px !important;
}

.language-flag.language-flag-custom-brazil .country-flag {
  background-position: 0 -1104px !important;
}

.language-flag.language-flag-custom-canada .country-flag {
  background-position: 0 -1120px !important;
}

.language-flag.language-flag-custom-chile .country-flag {
  background-position: 0 -1136px !important;
}

.language-flag.language-flag-custom-cote-d-ivoire .country-flag {
  background-position: 0 -1152px !important;
}

.language-flag.language-flag-custom-ecuador .country-flag {
  background-position: 0 -1168px !important;
}

.language-flag.language-flag-custom-egypt .country-flag {
  background-position: 0 -1184px !important;
}

.language-flag.language-flag-custom-england .country-flag {
  background-position: 0 -1200px !important;
}

.language-flag.language-flag-custom-luxembourg .country-flag {
  background-position: 0 -1216px !important;
}

.language-flag.language-flag-custom-malaysia .country-flag {
  background-position: 0 -1232px !important;
}

.language-flag.language-flag-custom-mexico .country-flag {
  background-position: 0 -1248px !important;
}

.language-flag.language-flag-custom-new-zealand .country-flag {
  background-position: 0 -1264px !important;
}

.language-flag.language-flag-custom-oman .country-flag {
  background-position: 0 -1280px !important;
}

.language-flag.language-flag-custom-qatar .country-flag {
  background-position: 0 -1296px !important;
}

.language-flag.language-flag-custom-saudi-arabia .country-flag {
  background-position: 0 -1312px !important;
}

.language-flag.language-flag-custom-singapore .country-flag {
  background-position: 0 -1328px !important;
}

.language-flag.language-flag-custom-south-africa .country-flag {
  background-position: 0 0 !important;
}

.language-flag.language-flag-custom-switzerland .country-flag {
  background-position: 0 -1344px !important;
}

.language-flag.language-flag-custom-syria .country-flag {
  background-position: 0 -1360px !important;
}

.language-flag.language-flag-custom-united-arab-emirates .country-flag {
  background-position: 0 -1376px !important;
}

.language-flag.language-flag-custom-united-states-of-america .country-flag {
  background-position: 0 -1392px !important;
}

.language-flag-hy .country-flag {
  background-position: 0 -1408px;
}

.language-flag-bs .country-flag {
  background-position: 0 -1424px;
}

.language-flag-ceb .country-flag {
  background-position: 0 -1440px;
}

.language-flag-ny .country-flag {
  background-position: 0 -1456px;
}

.language-flag-ha .country-flag {
  background-position: 0 -1472px;
}

.language-flag-hmn .country-flag {
  background-position: 0 -1488px;
}

.language-flag-ig .country-flag {
  background-position: 0 -1504px;
}

.language-flag-jw .country-flag {
  background-position: 0 -1520px;
}

.language-flag-kk .country-flag {
  background-position: 0 -1536px;
}

.language-flag-km .country-flag {
  background-position: 0 -1552px;
}

.language-flag-lo .country-flag {
  background-position: 0 -1568px;
}

.language-flag-la .country-flag {
  background-position: 0 -1584px;
}

.language-flag-mg .country-flag {
  background-position: 0 -1600px;
}

.language-flag-ml .country-flag {
  background-position: 0 -1616px;
}

.language-flag-mi .country-flag {
  background-position: 0 -1632px;
}

.language-flag-mr .country-flag {
  background-position: 0 -1648px;
}

.language-flag-mn .country-flag {
  background-position: 0 -1664px;
}

.language-flag-my .country-flag {
  background-position: 0 -1680px;
}

.language-flag-ne .country-flag {
  background-position: 0 -1696px;
}

.language-flag-pa .country-flag {
  background-position: 0 -1712px;
}

.language-flag-st .country-flag {
  background-position: 0 -1728px;
}

.language-flag-si .country-flag {
  background-position: 0 -1744px;
}

.language-flag-so .country-flag {
  background-position: 0 -1760px;
}

.language-flag-su .country-flag {
  background-position: 0 -1776px;
}

.language-flag-tg .country-flag {
  background-position: 0 -1792px;
}

.language-flag-uz .country-flag {
  background-position: 0 -1808px;
}

.language-flag-yo .country-flag {
  background-position: 0 -1824px;
}

.language-flag-zu .country-flag {
  background-position: 0 -1840px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue